import { Modal } from "antd";
import React, { useState } from "react";
import { NotificationImage, NotificationReadImage } from "../Icons";
import Notificationdrawer from "../Notificationdrawer";

const NotificationModal = ({ visible, onClose }) => {
  const [open, setOpen] = useState(false);

  const Close = () => {
    setOpen(false);
  };

  return (
    <Modal
      className="notification"
      title="Notifications"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
    >
      <div className="mainNotificationBox">
        <div className="last7days">Last 7 days</div>

        <div className="notificationmaindiv">
          <div className="notificationbox">
            <div className="notificationimg">
              <NotificationImage />
            </div>

            <div
              onClick={() => {
                setOpen(true);
              }}
              className="notificationtitle"
            >
              Documentation Update
              <div className="notificationdescription">
                Behaviour support Log has been updated.
                <span className="notificationspan">
                  {" "}
                  Please review the latest version.
                </span>
              </div>
              <div className="date">Apr 10</div>
            </div>

            <div className="notificationread">
              <NotificationReadImage />
            </div>
          </div>
        </div>

        <div className="notificationmaindiv">
          <div className="notificationbox">
            <div className="notificationimg">
              <NotificationImage />
            </div>

            <div
              onClick={() => {
                setOpen(true);
              }}
              className="notificationtitle"
            >
              Policy Update
              <div className="notificationdescription">
                Medication policy has been updated
                <span className="notificationspan">
                  {" "}
                  Please review the latest version.
                </span>
              </div>
              <div className="date">Apr 9</div>
            </div>

            <div className="notificationread">
              <NotificationReadImage />
            </div>
          </div>
        </div>

        <div className="last7days">Older</div>

        <div style={{ background: "#FFF" }} className="notificationmaindiv">
          <div className="notificationbox">
            <div className="notificationimg">
              <NotificationImage />
            </div>

            <div
              onClick={() => {
                setOpen(true);
              }}
              className="notificationtitle"
            >
              Documentation Update
              <div className="notificationdescription">
                Behaviour support Log has been updated.
                <span className="notificationspan">
                  {" "}
                  Please review the latest version.
                </span>
              </div>
              <div className="date">Mar 29</div>
            </div>

            <div className="notificationread">
              <NotificationReadImage />
            </div>
          </div>
        </div>

        <div className="markallread">Mark all as read</div>
      </div>

      <Notificationdrawer onClose={Close} drawerActiveTab={open} />
    </Modal>
  );
};

export default NotificationModal;
